import { render, staticRenderFns } from "./EmployerMatchFundingFrequencySelect.vue?vue&type=template&id=b996f80e&"
import script from "./EmployerMatchFundingFrequencySelect.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchFundingFrequencySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports